import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

// Общий поиск в сайдбаре (22.10.2026): с любой страницы — клиент или гражданское дело
// по номеру («71», «клиент 71», «дело 21»), ФИО, телефону, № дела в суде.
export default function GlobalSearch({ onNavigate }) {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [res, setRes] = useState(null);
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    const s = q.trim();
    if (!s) { setRes(null); return; }
    const t = setTimeout(() => {
      api.get('/search', { params: { q: s } }).then(r => { setRes(r.data); setOpen(true); }).catch(() => setRes(null));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => {
    const h = e => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const go = path => { setOpen(false); setQ(''); navigate(path); onNavigate && onNavigate(); };
  const items = res ? [
    ...res.clients.map(c => ({ key: 'c' + c.id, path: `/clients/${c.id}`, num: `клиент ${c.id}`, name: c.name, sub: c.type === 'court' ? 'судебное' : c.type === 'mfc' ? 'МФЦ' : '' })),
    ...res.cases.map(c => ({ key: 'd' + c.id, path: `/cases/${c.id}`, num: `дело ${c.id}`, name: c.client_name, sub: c.case_number || c.title || '' })),
  ] : [];

  return (
    <div ref={box} style={{ position: 'relative', padding: '0 12px 10px' }}>
      <input
        value={q}
        onChange={e => setQ(e.target.value)}
        onFocus={() => res && setOpen(true)}
        onKeyDown={e => { if (e.key === 'Enter' && items[0]) go(items[0].path); if (e.key === 'Escape') setOpen(false); }}
        placeholder="🔍 Номер, ФИО, телефон"
        style={{ width: '100%', boxSizing: 'border-box', padding: '7px 10px', fontSize: 13, border: '1px solid #dde3ea',
                 borderRadius: 8, outline: 'none', background: '#fff', color: '#1e2a3a' }}
      />
      {open && res && (
        <div style={{ position: 'absolute', left: 12, right: 12, top: '100%', marginTop: -6, zIndex: 50, background: '#fff',
                      border: '1px solid #dde3ea', borderRadius: 8, boxShadow: '0 6px 20px rgba(30,42,58,.12)', maxHeight: 340, overflowY: 'auto' }}>
          {items.length === 0 && <div style={{ padding: '10px 12px', fontSize: 12, color: '#8fa0b4' }}>Ничего не найдено</div>}
          {items.map(it => (
            <div key={it.key} onClick={() => go(it.path)}
                 style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f1f4f7' }}
                 onMouseEnter={e => { e.currentTarget.style.background = '#f5f8fb'; }}
                 onMouseLeave={e => { e.currentTarget.style.background = ''; }}>
              <div style={{ fontSize: 13, color: '#1e2a3a' }}>
                <span style={{ fontWeight: 700 }}>{it.num}</span> · {it.name}
              </div>
              {it.sub && <div style={{ fontSize: 11, color: '#8fa0b4', marginTop: 1 }}>{it.sub}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
